import { render } from "./PlaylistManager.vue?vue&type=template&id=18c1df23&scoped=true"
import script from "./PlaylistManager.vue?vue&type=script&lang=js"
export * from "./PlaylistManager.vue?vue&type=script&lang=js"

import "./PlaylistManager.vue?vue&type=style&index=0&id=18c1df23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c1df23"]])

export default __exports__